import { useEffect, type ReactNode } from 'react'
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context'
import { userManager } from './userManager'
import { setUnauthorizedHandler } from '../api/authBridge'

/**
 * Uygulama OIDC sağlayıcısı (research D6). Paylaşılan {@link userManager} ile `react-oidc-context`'i
 * sarar; altındaki tüm bileşenler `useAuth()` ile oturum/token durumuna erişir (`main.tsx`'te en dışta).
 *
 * <p>Ayrıca 401 köprüsünü (authBridge) bağlar (FR-015): korumalı bir istek 401 alınca (axios
 * interceptor → `onUnauthorized`) tek noktadan `signinRedirect` tetiklenir. `onSigninCallback` token
 * değişimi sonrası callback query'sini URL'den temizler.
 */
export default function AuthProvider({ children }: Readonly<{ children: ReactNode }>) {
  useEffect(() => {
    setUnauthorizedHandler(() => {
      userManager.signinRedirect()
    })
    return () => setUnauthorizedHandler(null)
  }, [])

  return (
    <OidcAuthProvider
      userManager={userManager}
      onSigninCallback={() => {
        window.history.replaceState({}, document.title, window.location.pathname)
      }}
    >
      {children}
    </OidcAuthProvider>
  )
}
